import cloneDeep from 'lodash/cloneDeep';
import baseDefaults from '../Base/Base.defaults';
import baseButtonDefaults from '../BaseButton/BaseButton.defaults';
import baseLabelDefaults from '../BaseLabel/BaseLabel.defaults';

export default {
  afterSubmitAction: {},
  ...cloneDeep(baseDefaults),

  baseFields: {
    variant: 'solid',
  },

  initialized: false,

  template: '',

  title: '',

  cover: {
    enabled: false,
    buttonText: 'I want more info',
  },

  forwardEmailAddresses: '',

  forwardEmailSubject: '',

  webhookPostUrl: '',

  automations: [],

  steps: [],

  label: cloneDeep(baseLabelDefaults),

  button: cloneDeep(baseButtonDefaults),

  afterSubmitMessage: 'Your form has been successfully submitted thank you',

  icon: {
    icon: {
      size: {value: 16, unit: 'px'},
      name: undefined,
    },
  },
};
